import {BaseProps, BaseSelectField, Value} from '../select-field/SelectField'

export interface Props<
  ValueType = unknown,
  AdditionalData extends Record<string, unknown> = Record<string, never>,
> extends Omit<BaseProps<ValueType, AdditionalData>, 'value' | 'onChange'> {
  value: Value<ValueType, AdditionalData>[]
  onChange?: (value: Value<ValueType, AdditionalData>[], name: string | undefined) => void
}

function MultiSelectField<
  ValueType = unknown,
  AdditionalData extends Record<string, unknown> = Record<string, unknown>,
>(props: Props<ValueType, AdditionalData>) {
  return <BaseSelectField<ValueType, AdditionalData> {...props} />
}

export default MultiSelectField
